/**
 * @file Defines H4 style
 */

import styled, { css } from 'styled-components';

let fontMax = 32;
let fontMin = 16;

const H4 = styled.h4`
  font-family: ${({ font }) => font ? font : 'SFSemiBold'};
  font-size: calc(${fontMin}px + (${fontMax} - ${fontMin}) * ((100vw - 320px) / (1920 - 320)));	
  text-align: ${({ align }) => align ? align : 'left'};
  line-height: ${({ height }) => height ? height : '48'}px;
  color: ${({ color }) => color ? color : '#373737'};
  transition: all 0.5s ease;

  ${({ maxWidth }) => maxWidth && css`
    max-width: ${maxWidth};
  `}
  @media screen and (max-width: 768px) {
    line-height:24px;
  }
  @media screen and (min-width: 1920px) {
    font-size: ${fontMax}px;
  }
`;

export default H4;